import React, { useCallback, useEffect, useState } from 'react';
import Icona from './Icone';
import GuidaInstalla from './GuidaInstalla';
import { useTraduzioni } from '../../i18n';
import {
  comeInstallare, daProporre, installaConInvito, installataAdesso, quandoCambia, rimanda,
} from '../../utils/installa';
import './installa.css';

// «Installate MK Client sul telefono»: la proposta, dove il cliente la incontra.
//
// Due modi di stare in pagina:
// - `variante="card"` (home del cliente, pagina di accesso): compare solo su un telefono, con l'app non
//   installata e senza un «Non ora» ancora valido. Installata l'app, sparisce da sola.
// - `variante="voce"` (Profilo › Notifiche): c'è **sempre**, anche da computer e ad app già installata — lì
//   dice semplicemente che è già a posto. È il posto dove uno va a cercarla quando gli serve, e non trovarla
//   sarebbe peggio che vederla inutile.
//
// Al tocco di «Installa» succedono due cose diverse a seconda del telefono, e il cliente non deve saperlo:
// su Android, se Chrome ha offerto l'installazione, si apre la finestra vera del sistema; altrimenti (e sempre
// su iPhone) si apre la guida con i passi (utils/installa.js, GuidaInstalla.jsx).

const CardInstalla = ({ variante = 'card' }) => {
  const { t } = useTraduzioni();
  const voce = variante === 'voce';
  const [guida, setGuida] = useState(false);
  const [nascosta, setNascosta] = useState(false);
  const [attesa, setAttesa] = useState(false);
  // il modulo avvisa quando arriva l'invito di Chrome o quando l'app viene installata: la card si ridisegna
  const [, ridisegna] = useState(0);
  useEffect(() => quandoCambia(() => ridisegna((n) => n + 1)), []);

  const installa = useCallback(async () => {
    if (comeInstallare() === 'invito') {
      setAttesa(true);
      const esito = await installaConInvito();
      setAttesa(false);
      if (esito) return;          // accettata o rifiutata: in tutti e due i casi ha deciso il cliente
    }
    setGuida(true);               // niente invito (iPhone, o Chrome che non l'ha offerto): i passi a mano
  }, []);

  const nonOra = () => { rimanda(); setNascosta(true); };

  const installata = installataAdesso();
  if (!voce && (nascosta || !daProporre())) return null;

  return (
    <>
      {/* le due classi convivono: dentro le pagine del cliente vince `.mk-home .search` (più specifica) e la
          card sta in fila con le altre; nella pagina di accesso, che ha un altro stile, vale `.mk-installa-card` */}
      <div className="search r card-installa mk-installa-card" data-testid="card-installa"
        data-variante={variante} data-installata={installata ? 'si' : 'no'}>
        <div className="items">
          <div className="it">
            <div className="i"><Icona nome="telefono_app" /></div>
            <div>
              <b style={{ fontSize: '1.1rem' }}>{voce ? t('installa.voce') : t('installa.titolo')}</b>
              <span>{installata ? t('installa.gia_installata') : voce ? t('installa.voce_testo') : t('installa.testo')}</span>
            </div>
          </div>
        </div>
        {!installata && (
          <div>
            <button type="button" className="btn sm p" onClick={installa} disabled={attesa} data-testid="installa-avvia">
              {t('installa.installa')}
            </button>
            {voce ? (
              <button type="button" className="btn sm" style={{ marginLeft: 0 }} onClick={() => setGuida(true)}
                data-testid="installa-come">
                {t('installa.apri_guida')}
              </button>
            ) : (
              <button type="button" className="btn sm" style={{ marginLeft: 0 }} onClick={nonOra}
                data-testid="installa-non-ora">
                {t('installa.non_ora')}
              </button>
            )}
          </div>
        )}
      </div>
      {guida && <GuidaInstalla onChiudi={() => setGuida(false)} />}
    </>
  );
};

export default CardInstalla;
